//COMPANIES STRUCTURES
const COMPANY_STRUCTURES = {
  COMPANY_STRUCTURE_NO_BOX: 'nobox',
  COMPANY_STRUCTURE_PERSONAL: 'personal',
  COMPANY_STRUCTURE_SOLE_PROPRIETORSHIP: 'soleproprietorship',
  COMPANY_STRUCTURE_ASSOCIATION: 'association',
  COMPANY_STRUCTURE_UNREGISTERED: 'unregistered',
  COMPANY_STRUCTURE_FAMILY: 'family',
}

export const COMPANY_PERSONAL_STRUCTURE_TYPES = [
  COMPANY_STRUCTURES.COMPANY_STRUCTURE_NO_BOX,
  COMPANY_STRUCTURES.COMPANY_STRUCTURE_PERSONAL,
  COMPANY_STRUCTURES.COMPANY_STRUCTURE_UNREGISTERED,
  COMPANY_STRUCTURES.COMPANY_STRUCTURE_FAMILY,
]
